import React from 'react';
import { config } from '../../config';
import heroBg from '../../assets/hero-bg.jpg';

export const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-secondary">
      {/* Background with Parallax Effect (simulated with fixed) */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroBg}
          alt="Church"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover opacity-60 scale-105 animate-float"
          style={{ animationDuration: '20s' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary via-secondary/80 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-secondary via-transparent to-transparent"></div>
      </div>

      <div className="container-custom relative z-10 pt-20">
        <div className="max-w-4xl">
          <div className="flex items-center gap-6 mb-12 animate-fade-in">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 blur-2xl rounded-full transform scale-150"></div>
              <img 
                src={config.logo}
                alt={config.church_name}
                loading="eager"
                decoding="async"
                className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-2 border-white/10 shadow-2xl"
              />
            </div>
            <div className="inline-flex items-center gap-3 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
              </span>
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-primary-light">Welcome to our family</span>
            </div>
          </div>

          <h1 className="text-5xl sm:text-7xl lg:text-9xl font-bold text-white leading-[0.9] mb-8 animate-fade-in-up stagger-1">
            Experience <br />
            <span className="text-primary italic font-light">Grace</span> & Truth
          </h1>

          <p className="text-lg sm:text-xl text-accent/80 font-light leading-relaxed mb-12 max-w-2xl animate-fade-in-up stagger-2 text-balance">
            {config.church_name} is a vibrant community in {config.tagline} dedicated to teaching the Word of God and demonstrating the love of Christ through practical living.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 animate-fade-in-up stagger-3">
            <a href="#contact" className="btn-primary group">
              <span>Join Us This Sunday</span>
              <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
            <a href="#about" className="btn-outline">
              Learn Our Story
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce opacity-50">
        <div className="w-6 h-10 rounded-full border-2 border-white flex justify-center p-1">
          <div className="w-1.5 h-2 bg-white rounded-full"></div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-1/4 right-0 w-64 h-64 bg-primary/10 blur-[120px] rounded-full"></div>
      <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-primary/5 blur-[150px] rounded-full"></div>
    </section>
  );
};
